// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "global." + chunkId + "." + {"301":"89accad776e4b6f9eedf","665":"fc2b77b34a726b1137ff"}[chunkId] + ".js";
};